import { Switch } from 'antd';
import { useFormikContext } from 'formik';
import { OfferType } from 'legacy/events/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdDiscount } from 'react-icons/md';

interface PromoterDiscountCardProps {
  setShouldShowCreateForm: (show: boolean) => void;
}

const PromoterDiscountCard = ({
  setShouldShowCreateForm
}: PromoterDiscountCardProps) => {
  const { t } = useTranslation('events');
  const { values, setFieldValue } = useFormikContext<OfferType>();
  const promoterDiscount = values.discount;
  const isOfferActive = promoterDiscount?.isActive ?? true;
  const sign = promoterDiscount?.kind === 'percentage' ? '%' : '$';

  const handleToggleOfferActive = (e) => {
    e.stopPropagation();
    setFieldValue('discount.isActive', !isOfferActive);
  };

  return (
    <div>
      <div
        className="cursor-pointer mt-4 border border-[#EBEBEB] rounded-lg p-4"
        onClick={() => setShouldShowCreateForm(true)}
      >
        <div className="flex flex-row">
          <MdDiscount size={20} color="#575757" />
          <div className="text-sm font-bold text-[#575757] ml-2">
            {promoterDiscount.value} {sign}
          </div>
          {promoterDiscount?.usageLimitPerContract && (
            <div className="text-sm font-bold text-[#575757] ml-2">
              • {promoterDiscount.usageLimitPerContract} {t('settings.promoterOffers.promoterDiscount.card.times')}
            </div>
          )}
        </div>
        <div
          className="flex flex-row mt-4 items-center"
          onClick={handleToggleOfferActive}
        >
          <div>{t('settings.promoterOffers.promoterDiscount.card.active')}</div>
          <Switch checked={isOfferActive} className="ml-2" />
        </div>
      </div>
      <div className="mt-4 flex items-center">
        <div className="w-full border-b-1 border-gray-200" />
        <button
          type="button"
          className="pl-4 text-red-700 text-sm"
          onClick={() => setFieldValue('discount', null)}
        >
          {t('settings.promoterOffers.promoterDiscount.card.remove')}
        </button>
      </div>
    </div>
  );
};

export default PromoterDiscountCard;
